
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { i18n } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
  };

  const navLinks = [
    { key: 'about', href: '#about', label: 'About' },
    { key: 'services', href: '#services', label: 'Services' },
    { key: 'regional', href: '#regional', label: 'Regional' },
    { key: 'faq', href: '#faq', label: 'Faq' },
    { key: 'contact', href: '#contact', label: 'Contact' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md' : 'bg-[#C8D9E6]'
      }`}
    >
      <div className="w-full px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/4bdd8f0f3f64793b594ebaf891f5a54a/26ff1389f2f6e943de2bc36658d6bfba.png"
              alt="Kimberlite Logo"
              className="h-20 w-auto"
              style={{ 
                filter: 'brightness(1) contrast(1.1)',
                background: 'transparent',
                padding: '4px'
              }}
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.key}
                href={link.href}
                className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  isScrolled
                    ? 'text-gray-700 hover:text-[#1A5F7A]'
                    : 'text-gray-800 hover:text-[#1A5F7A]'
                }`}
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={toggleLanguage}
              className={`px-4 py-2 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                isScrolled
                  ? 'bg-[#1A5F7A] text-white hover:bg-[#134A5E]'
                  : 'bg-[#1A5F7A] text-white hover:bg-[#134A5E]'
              }`}
            >
              {i18n.language === 'en' ? 'العربية' : 'English'}
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-gray-700' : 'text-gray-800'
            }`}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-300">
            <div className="flex flex-col gap-4 mt-4">
              {navLinks.map((link) => (
                <a
                  key={link.key}
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`font-medium transition-colors cursor-pointer ${
                    isScrolled
                      ? 'text-gray-700 hover:text-[#1A5F7A]'
                      : 'text-gray-800 hover:text-[#1A5F7A]'
                  }`}
                >
                  {link.label}
                </a>
              ))}
              <button
                onClick={() => {
                  toggleLanguage();
                  setIsMobileMenuOpen(false);
                }}
                className={`px-4 py-2 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap text-left ${
                  isScrolled
                    ? 'bg-[#1A5F7A] text-white hover:bg-[#134A5E]'
                    : 'bg-[#1A5F7A] text-white hover:bg-[#134A5E]'
                }`}
              >
                {i18n.language === 'en' ? 'العربية' : 'English'}
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
